import React, { useEffect, useState } from 'react'
import { DataTable, DataTableRow, Divider, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getOdmSubmissions } from '../../../services/OdvService'
import useNotifications from '../../../hooks/useNotifications'
import { getFrontendBaseUrl } from '../../../util/UrlUtil'

export default function OdmSubmissionView({ submissionQuery }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()
  const [submissions, setSubmissions] = useState([])

  useEffect(() => {
    getOdmSubmissions(submissionQuery)
      .then((response) => {
        if (response.data) {
          setSubmissions(response.data)
          ok(t('odv.found', 'Found { count } records', { count: response.data.size }))
        } else {
          setSubmissions(null)
        }
      })
      .catch((err) => {
        setSubmissions(null)
        error(
          t('odv.search.errors.gettingOdmSubmissionSearchResults', {
            defaultValue: `Error getting ODM submission search results: ${err.message || ''}`,
            message: err.message,
          }),
          err
        )
      })
  }, [submissionQuery, error, ok, t])

  return (
    <>
      <Divider marginY="nano" />
      <H5>{t('odm.submissions', 'Submissions')}</H5>
      <Divider marginY="nano" />
      {submissions && submissions?.length > 0 && (
        <DataTable
          columns={[
            { label: t('odm.submission.submitter', 'Submitter'), size: 'lg' },
            { label: t('odm.submission.city', 'City'), size: 'lg' },
            { label: t('odm.submission.phone', 'Phone'), size: 'md' },
            { label: t('odm.submission.submission', 'Submission'), size: 'md' },
            { label: t('odm.submission.publish', 'Pub'), size: 'xs' },
            { label: t('odm.submission.date', 'Date'), size: 'sm' },
            { label: t('odm.submission.cards', 'Cards'), size: 'xs' },
            { label: t('odm.submission.temple', 'Temple'), size: 'sm' },
          ]}
        >
          {submissions?.map((submission) => {
            return (
              <DataTableRow
                key={submission.submission}
                column1={submission.submitter}
                column2={submission.city}
                column3={submission.phone}
                column4={submission.submission}
                column5={submission.publish}
                column6={submission.date}
                column7={submission.cards?.length}
                column8={submission.temple}
                onClick={() => window.open(`${getFrontendBaseUrl()}/temple/request/${submission.submission}`, '_blank')}
              />
            )
          })}
        </DataTable>
      )}
      {!submissions && <p id="odmSubmissionNoResults">{t('odm.noSubmissions', 'No Submissions Found')}</p>}
      <Divider marginY="nano" />
    </>
  )
}
